import CustomerJson from "./customer";
import ProductJson from "./product";

const getTotalPrice = function (products) {
  let total = 0;
  products.forEach((product) => {
    total += parseFloat(product.unit_price) * parseInt(product.quantity);
  });
  return total;
};

export default function (order = {}, products = [], customer = {}) {
  this.extra_costs = 0;
  this.delivery_cost = "0";
  this.tip_price = "0";
  this.discount = "0";
  this.is_discount_percentage = 0;
  this.order_products = products.map((product) => new ProductJson(product));
  this.session_id = order.session_id;
  this.is_round = order.is_round;
  this.shop_id = order.shop_id ? order.shop_id : null;
  this.table_number = order.table_number ? order.table_number : null;
  this.daily_order_number = order.daily_order_number ? order.daily_order_number : null;
  this.order_number = order.order_number ? order.order_number : null;
  this.customer = new CustomerJson(customer);
  this.requested_time = order.requested_time;
  this.order_datetime = order.order_datetime;
  this.number_of_guests = 0;
  this.is_pos_sync = 0;

  this.order_status_code = process.env.VUE_APP_ORDER_STATUS_ID;
  this.order_source_code = process.env.VUE_APP_ORDER_SOURCE_ID;
  this.order_type_code = process.env.VUE_APP_ORDER_TYPE_ID;
  this.courier_type_code = process.env.VUE_APP_COURIER_TYPE_ID;

  this.order_remark = order.order_remark ? order.order_remark : "";

  this.payment_methods = order.payment_methods;
}
